import { CardHeader, Paper } from "@material-ui/core";
import { useEffect, useState } from "react";
import { Sync } from "@material-ui/icons";
import { HttpClient } from "../../../web-services/http-client";
import { IVjtData } from "../../../web-services/models/vjt-data";
import { IParkingZoneData } from "../../../web-services/models/parking-zone-data";
import { objectToFormData } from "../../../web-services/utils/object-to-form-data";
import { ProgressDialog } from "../../common/progress-dialog";
import { VjtGetterCard } from "./components/vjt-getter-card";
import "./vjt-page.scss";
import { VjtTable } from "./components/vjt-table";
import { VjtEditDialog } from "./vjt-edit-dialog";
import {ISablonData} from "../../../web-services/models/sablon-data";
import {useLocation} from "react-router-dom";
type LocationState = {
    megnevezes?: string;
};
// eslint-disable-next-line @typescript-eslint/naming-convention
export function VjtPage(props: { httpClient: HttpClient })
{    const location = useLocation();
    const { megnevezes } = location.state as LocationState || {};
    const [localMegnevezes , setLocalMegnevezes] = useState(megnevezes  || ''); // Initialize megnevezes with the value from state or an empty string
    const [progressDialogOpened, setProgressDialogOpened] = useState<boolean>(false);
    const [vjtDialogOpened, setVjtDialogOpened] = useState<boolean>(false);
    const [errorMsg, setErrorMsg] = useState<string>();
    const [errorCategoryMsg, setErrorCategoryMsg] = useState<string>();
    const [isSendingRequest, setIsSendingRequest] = useState<boolean>(true);
    const [tableData, setTableData] = useState<IVjtData[]>([]);
    const [selectedVjt, setSelectedVjt] = useState<IVjtData>();
    const [parkingZoneData, setParkingZoneData] = useState<IParkingZoneData[]>([]);
    const [sablonData, setSablonData] = useState<ISablonData[]>([]);

    useEffect(() =>
    {
        fetchDataForVjtTable();
        fetchParkingLotsData();
        fetchDataForSablon();
    }, [isSendingRequest]);

    const fetchParkingLotsData = () =>
    {
        if (parkingZoneData.length > 0) return;
        const fetchData = async () =>
        {
            setErrorMsg(undefined);
            setErrorCategoryMsg(undefined);
            try
            {
                let data = (await props.httpClient.get<IParkingZoneData[]>("values/get-parking-lot", "", 15000)).data;
                setParkingZoneData(data || []);
            }
            catch (err: any)
            {
                console.log(err);

                if (err.message === "Nem várt hiba történt.")
                {
                    setErrorCategoryMsg("Kapcsolati hiba");
                    setErrorMsg("Kérjük, próbálja újra a parkolózónák letöltését.");
                }
                else
                {
                    setErrorMsg(err.message);
                }
            }
        };

        fetchData().catch(console.error);
    };

    const fetchDataForVjtTable = () =>
    {
        if (!isSendingRequest) return;

        setProgressDialogOpened(true);

        const fetchData = async () =>
        {
            // Tabula rasa at the beginning.
            setErrorMsg(undefined);
            setErrorCategoryMsg(undefined);

            try
            {
                let data = (await props.httpClient.post<IVjtData[]>(
                    "vjt/post-table-data",
                    "",
                    objectToFormData({
                        megnevezes: localMegnevezes
                    }),
                    15000
                )).data;

                setTableData(data || []);
                setProgressDialogOpened(false);
            }
            catch (err: any)
            {
                console.log(err);

                // Check for generic error message in case of backend being down for example.
                if (err.message === "Nem várt hiba történt.")
                {
                    setErrorCategoryMsg("Kapcsolati hiba");
                    setErrorMsg("Kérjük, próbálja újra az adatlekérést.");
                }
                else
                {
                    setErrorMsg(err.message);
                }
            }

            setIsSendingRequest(false);
        };

        fetchData().catch(console.error);
    };
    const fetchDataForSablon = () =>
    {
        if (sablonData.length > 0) return;
        const fetchData = async () =>
        {
            setErrorMsg(undefined);
            setErrorCategoryMsg(undefined);
            try
            {
                let data = (await props.httpClient.get<IParkingZoneData[]>("sablon/get-sablon-data", "", 15000)).data;
                setSablonData(data || []);
            }
            catch (err: any)
            {
                console.log(err);

                if (err.message === "Nem várt hiba történt.")
                {
                    setErrorCategoryMsg("Kapcsolati hiba");
                    setErrorMsg("Kérjük, próbálja újra a sablonok letöltését.");
                }
                else
                {
                    setErrorMsg(err.message);
                }
            }
        };

        fetchData().catch(console.error);
    };

    const handleModifyButtonClick = (vjt: IVjtData) =>
    {
        setSelectedVjt(vjt);
        setVjtDialogOpened(true);
    };

    const handleSaveSuccess = () =>
    {
        setVjtDialogOpened(false);
        setIsSendingRequest(true);
    };

    return (
        <div className="scrollable-container">
            <VjtEditDialog
                onSaveSuccess={handleSaveSuccess}
                httpClient={props.httpClient}
                vjt={selectedVjt}
                parkingLots={parkingZoneData}
                open={vjtDialogOpened}
                onClose={() => setVjtDialogOpened(false)}
                sablonok={sablonData}
            />
            <ProgressDialog
                text="Adatlekérés folyamatban"
                retryButtonText="Újra lekérem"
                onRetryButtonClick={() => setIsSendingRequest(true)}
                onCancelButtonClick={() => setProgressDialogOpened(false)}
                retryButtonIcon={<Sync />}
                errorText={errorMsg}
                errorCategoryText={errorCategoryMsg}
                open={progressDialogOpened}
            />
            <Paper className="main-paper">
                <CardHeader title="Kijelzők" />
                <VjtGetterCard
                    megnevezes={localMegnevezes}
                    onButtonClick={() => setIsSendingRequest(true)}
                    onMegnevezesChange={(newMegnevezes: string) => setLocalMegnevezes(newMegnevezes)}
                />
                <VjtTable data={tableData} onModifyButtonClick={handleModifyButtonClick} />
            </Paper>
        </div>
    );
}
